import React, { useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import ExtraPricesSettingsPage from "./ExtraPrices";
import GeneralPriceSettingsPage from "./GeneralPrices";
import PayPerUseSettingsPage from "src/pages/Dashboard/Settings/PriceList/Prices/PayPerUseProducts";

const PricesSettingsPage = () => {
  const [activeTab, setActiveTab] = useState("prices");

  return (
    <>
      <Row>
        <Col>
          <Tabs
            activeKey={activeTab}
            onSelect={(tab) => {
              setActiveTab(tab);
            }}
          >
            <Tab title="Stellplätze" eventKey={"prices"}>
              {activeTab === "prices" && <GeneralPriceSettingsPage />}
            </Tab>
            <Tab title="Extras" eventKey={"extraPrices"}>
              {activeTab === "extraPrices" && <ExtraPricesSettingsPage />}
            </Tab>
            <Tab title="Pay Per Use Produkte" eventKey={"pay-per-use-products"}>
              {activeTab === "pay-per-use-products" && (
                <PayPerUseSettingsPage />
              )}
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default PricesSettingsPage;
